import { Modal, Pagination } from "react-bootstrap";
import Axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import Spinner from "../component/Spinner";
import { URL_LIST_ALL } from "../configs/api";
import Select from 'react-select'

export default function ModalLoaiToTrinh(props) {
    const {
        onChange,
    } = props;
    const { user } = useSelector((state) => state.auth);
    const [selectedItems, setSelectedItems] = useState(null);
    const [show, setShow] = useState(false);
    const [keySearch, setKeySearch] = useState("");
    const [departmentId, setDepartmentId] = useState({ value: user.data.part_id, label: user.data.part_title });
    const [useType, setUseType] = useState(0);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalpage, setTotalpage] = useState(0);
    const [listData, setListData] = useState([]);
    const [listDepartment, setListDepartment] = useState([]);
    const [totalRecord, setTotalRecord] = useState(10);

    useEffect(() => {
        let mounted = true;
        if (show) {
            setLoading(true);
            let part_id = useType == 1 ? departmentId.value : "all"

            Axios.get(URL_LIST_ALL + "crm_workflow_type?limit=1000&status=1&page=" + page + "&part_id=" + part_id + (keySearch ? "&title="+keySearch : ""), user.config)
                .then((res) => {
                    setLoading(false);
                    if (res.data && res.data.status === "success") {
                        if (mounted) {
                            setListData(res.data.data)
                            setTotalpage(res.data.totalpage);
                            setTotalRecord(res.data.total);
                        }
                    } else console.log(res.data.message);
                })
                .catch((err) => {
                    console.log(err);
                    setLoading(false);
                });
        }
        return () => (mounted = false);
    }, [user, show, departmentId,useType,keySearch]);

    useEffect(() => {
        let mounted = true;
        setLoading(true);
        let config = {
            headers: {
                Authorization: "Bearer " + user.access_token,
                asselect: JSON.stringify(["id as value", "title as label"]),
            },
        };
        Axios.get(URL_LIST_ALL + "parts?limit=1000", config)
            .then((res) => {
                setLoading(false);
                if (res.data && res.data.status === "success") {
                    if (mounted) {
                        setListDepartment(res.data.data)
                    }
                } else console.log(res.data.message);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
        return () => (mounted = false);
    }, [user, show]);

    // Toggle chọn item
    const toggleSelect = (item) => {
        setSelectedItems({ value: item.id, label: item.title });
        onChange(item.id);
        setShow(false);
    };

    return (
        <div className="search-box-modal height32">
            <div className="input-group mb-3">
                <input
                    type="text"
                    className="form-control height32"
                    value={(selectedItems?.label || "")}
                    readOnly
                    placeholder={"Chọn loại tờ trình"}
                />
                <input
                    type="hidden"
                    name="type"
                    value={(selectedItems?.value || "")}
                />
                <div className="input-group-prepend">
                    <button type="button" className="btn btn-sm btn-success height32" onClick={() => setShow(true)}>
                        Chọn
                    </button>
                </div>
            </div>
            <Modal show={show} onHide={() => setShow(false)} animation={true} size="md">
                <Modal.Header closeButton>
                    <Modal.Title>Chọn loại tờ trình</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="w-100 list-search-box">
                        <div className="input-group mb-3">
                            <input
                                type="text"
                                className="form-control height32"
                                placeholder="Tìm kiếm"
                                onChange={(e) => setKeySearch(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        if (keySearch && keySearch.trim() !== '') {
                                            setKeySearch(keySearch.trim());
                                        }
                                    }
                                }}
                            />
                            <div className="input-group-prepend">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-success height32"
                                    onClick={() => {
                                        if (keySearch && keySearch !== "") {
                                            // searchOnchange(keySearch.trim());
                                        }
                                    }}
                                >
                                    <span className="fas fa-search"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="list-tab mt-2">
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <button className={"btn " + (useType == 0 ? "btn-success" : "btn-outline-success")}
                                    onClick={() => setUseType(0)}>
                                    Sử dụng chung
                                </button>
                            </div>
                            <div className="col-12 col-sm-8" onClick={() => setUseType(1)}>
                                <Select className={"w-100 select-multiple " + (useType == 1 ? "type-selected" : "")} value={departmentId} options={listDepartment} placeholder="Chọn phòng ban" onChange={setDepartmentId} />
                            </div>
                        </div>
                    </div>
                    {loading && (
                        <div className="w-100 d-flex justify-content-center pt-3 pb-3">
                            <Spinner />
                        </div>
                    )}
                    <div className="w-100 list-search-box mt-2">
                        <ul className="w-100 list-data">
                            {listData.map((item) => {
                                const isSelected = selectedItems ? selectedItems.value == item.id : null
                                return (
                                    <li
                                        key={item.id}
                                        onClick={() => toggleSelect(item)}
                                        className={isSelected ? "active" : ""}
                                        style={{
                                            cursor: "pointer",
                                            fontWeight: isSelected ? "bold" : "normal",
                                        }}
                                    >
                                        {item.title}
                                    </li>
                                );
                            })}
                            {listData.length == 0 && <li>Không có dữ liệu</li>}
                        </ul>
                        {totalpage > 1 && (
                            <div className="w-100 d-flex justify-content-center mt-2 pagination-group">
                                <Pagination
                                    activePage={page}
                                    itemsCountPerPage={10}
                                    totalItemsCount={totalRecord}
                                    pageRangeDisplayed={5}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    prevPageText="<"
                                    nextPageText=">"
                                    onChange={setPage}
                                />
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}